// Veteran Topic 3 — Smart Money Concepts. Notes + infographics (scenes in scenes/advanced.jsx).
export default {
  title: 'Smart Money Concepts',
  summary: 'How big players hunt stops, set traps, and buy cheap.',
  subtopics: [
    { title: 'Liquidity', scene: 'smcLiq', cards: [
      { icon: '💧', title: 'Liquidity = orders', body: 'Liquidity is a pile of waiting orders, mostly stop losses.' },
      { icon: '🟰', title: 'Equal highs and lows', body: 'Many traders put stops just above equal highs or below equal lows.' },
      { icon: '🧹', title: 'The sweep', body: 'Big players push price into those stops, fill their big orders, then price often turns back.' },
      { icon: '🟡', title: 'Gold example', body: 'Equal highs at 2,430. Gold wicks to 2,452, takes the stops, then closes back below and falls.' },
    ] },
    { title: 'Inducement', scene: 'smcInd', cards: [
      { icon: '🪤', title: 'A trap', body: 'Inducement is a small, obvious level that tempts traders to enter too early.' },
      { icon: '🧀', title: 'The bait', body: 'Early traders buy there and put stops just below.' },
      { icon: '🧹', title: 'Taken first', body: 'Price takes those stops, then reaches the real zone (like an order block) and moves.' },
      { icon: '⏳', title: 'Your rule', body: 'Wait for the inducement to be swept before you look for an entry.' },
    ] },
    { title: 'Premium & Discount Zones', scene: 'smcPD', cards: [
      { icon: '✂️', title: 'Split the swing in half', body: 'Draw from swing low to swing high. The middle (50%) is equilibrium.' },
      { icon: '💎', title: 'Premium', body: 'Above 50% is expensive. Good area to look for sells.' },
      { icon: '🏷️', title: 'Discount', body: 'Below 50% is cheap. Good area to look for buys.' },
      { icon: '🟡', title: 'Gold example', body: 'Swing 2,330 → 2,470. Middle is 2,400. In an uptrend, look to buy below 2,400.' },
    ] },
    { title: 'Combining Them for an Entry', scene: 'smcCombo', cards: [
      { icon: '1️⃣', title: 'Trend', body: 'Find the trend with market structure (HH/HL).' },
      { icon: '2️⃣', title: 'Discount + liquidity', body: 'Wait for price to pull back into discount and sweep a low (inducement).' },
      { icon: '3️⃣', title: 'Zone + close', body: 'Price reaches an order block or FVG and a bullish candle closes.' },
      { icon: '4️⃣', title: 'Risk', body: 'Stop below the zone, target the recent high, risk only 1–2%.' },
    ] },
  ],
};
